import { WithMongooseProps } from '@runelab/odin-common'

export enum AdditionalFieldTypeEnum {
  FREE = 'free',
  SELECT = 'select',
}

export type TicketAdditionalField = WithMongooseProps<{
  name: string
  additionalFieldType: AdditionalFieldTypeEnum
  options: string[]
  isRequired: boolean
}>
